// Team data — Joe & Victoria, the Beasts of Claim Beast

export const team = [
  {
    slug: "joe",
    name: "Joe",
    role: "Lead Public Adjuster & Co-Owner",
    photo:
      "https://customer-assets.emergentagent.com/job_tampa-adjuster-pro/artifacts/mip5nclz_113AADB8-0A0D-49EB-82B2-12805A65C0CB.PNG",
    licenses: {
      florida: "W757540",
      georgia: "3750441",
    },
    yearsExperience: "10+",
    specialties: [
      "Hurricane & windstorm claims",
      "Denied & underpaid claim reopens",
      "Commercial property losses",
      "Complex multi-line negotiations",
    ],
    bio: [
      "Joe leads every Claim Beast file with one rule: the insurance company doesn't get the last word. After watching too many Florida homeowners get steamrolled by carriers after major storms, he founded Claim Beast to flip the table.",
      "Joe is a Florida and Georgia licensed public adjuster with over a decade of insurance industry experience on both sides of the table — meaning he knows exactly how the carriers think and exactly how to beat them.",
      "When he's not on a rooftop documenting wind damage, you'll find him with his family in Riverview, on the water in Apollo Beach, or coaching his kids' teams.",
    ],
    quote:
      "Every homeowner deserves an advocate who fights as hard for their settlement as the insurance company fights to avoid paying it.",
  },
  {
    slug: "victoria",
    name: "Victoria",
    role: "Public Adjuster & Co-Owner",
    photo:
      "https://customer-assets.emergentagent.com/job_ababf03b-d60e-4de6-805e-a9bd3c0ebb04/artifacts/h8mee1i0_IMG_6687%20%281%29.JPG",
    licenses: {
      florida: "G249757",
    },
    yearsExperience: "8+",
    specialties: [
      "Residential property claims",
      "Water, fire & mold losses",
      "Documentation & estimate preparation",
      "Client advocacy & communication",
    ],
    bio: [
      "Victoria is the engine behind every Claim Beast file — the meticulous documentation, the Xactimate estimates, and the relentless follow-up that turns a denied claim into a full payout.",
      "A Florida licensed public adjuster, Victoria spent years inside the industry before joining Claim Beast. She brings a homeowner-first approach that pairs precision documentation with genuine compassion for clients going through their worst day.",
      "A proud Tampa Bay local, Victoria has helped Riverview, Tampa and Brandon homeowners recover millions from carriers that originally tried to settle for pennies.",
    ],
    quote:
      "Insurance is a promise. Our job is to make sure the carrier keeps it.",
  },
];
